import React, { Component } from 'react'

class Home extends Component {
  render () {
    return (
      <div className='home'>
        <h1>Please Sign In above <br/> to get posting!</h1>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/routes/Home.js